<div class="focus-section">
  <div class="secondary-background colored-text small-padding">
    <div class="focus-content">
      <div class="k-icon k-i-search small-padding"></div>
      <b>Mes préférences</b>
      <kendo-dropdownlist
        [data]="listModalite"
        [textField]="'libelle'"
        [valueField]="'id'"
        [value]="selectedModa"
        [valuePrimitive]="true"
        class="small-padding"
        (selectionChange)="changeModalite($event)"
      ></kendo-dropdownlist>
      <input
        kendoTextBox
        maxlength="5"
        [placeholder]="'Code postal'"
        class="small-padding"
        [ngModel]="postal"
        (keyup)="onPostalValueChange($event)"
      />
      <!-- <kendo-maskedtextbox mask="00000" [(value)]="postal"></kendo-maskedtextbox> -->
    </div>
  </div>
  <div class="small-padding">
    <div [ngStyle]="getBackgroundStyle()"></div>
    <div class="focus-content" *ngIf=" !!infoFormation &&  infoFormation.focus">
      <p class="small-padding" >
        <b>{{ !!infoFormation ? infoFormation.focus.accroche : '' }}</b>
      </p>
      <div *ngIf="!!infoFormation.focus.objectifs" class="small-padding">
        <div class="k-icon k-i-check-circle small-padding"></div>
        <b>Objectif pédagogique</b>
        <div [innerHTML]="infoFormation.focus.objectifs"></div>
      </div>
      <div *ngIf="!!infoFormation.focus.public" class="small-padding">
        <div class="k-icon k-i-user small-padding"></div>
        <b>Public concerné</b>
        <div [innerHTML]="infoFormation.focus.public"></div>
      </div>
    </div>
  </div>
  <div class="inscript-content">
    <ags-fiche-formation-inscription
      [infoFormation]="infoFormation"
      [postal]="postal"
      [modalite]="selectedModa"
    ></ags-fiche-formation-inscription>
  </div>
</div>
